import { useOutletContext } from "react-router-dom";
import { Sparkles, Users, HeartHandshake, Compass } from "lucide-react";

const pillars = [
  { icon: Sparkles, name: "FÉ", desc: "Relacionamento genuíno com Deus, sem religiosidade fria." },
  { icon: Users, name: "COMUNHÃO", desc: "Mesa aberta, risadas e conexões reais que duram." },
  { icon: HeartHandshake, name: "AMIZADE", desc: "Um lugar seguro para ser você mesmo e crescer junto." },
  { icon: Compass, name: "PROPÓSITO", desc: "Despertando a juventude para impactar sua geração." },
];

export default function About() {
  const { settings } = useOutletContext();
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-16">
      <div className="label">Sobre o Inefável</div>
      <h1 className="font-display text-4xl sm:text-6xl font-black mt-2">
        Mais do que um encontro.<br /><span className="text-blue-400 text-glow-blue">Uma conexão.</span>
      </h1>
      <p className="text-slate-300 mt-6 text-lg leading-relaxed max-w-3xl">{settings?.about_text}</p>
      <blockquote className="mt-10 border-l-2 border-blue-400 pl-6 font-display text-2xl sm:text-3xl text-white italic">
        "Porque há momentos que não conseguimos explicar, apenas viver."
      </blockquote>

      <div className="mt-16 grid gap-5 sm:grid-cols-2">
        {pillars.map(({ icon: Icon, name, desc }) => (
          <div key={name} className="ci-card p-7">
            <Icon size={32} className="text-blue-400" />
            <h3 className="mt-4 font-display text-2xl font-bold">{name}</h3>
            <p className="mt-2 text-slate-300">{desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
